import React from 'react'

const Navbar = () => {
    return (
        <React.Fragment>
            {/* <!-- Top header start --> */}
            <header className="navbar sticky-top navbar-light bg-dark">
                <div className="container">
                    <nav className="navbar navbar-light bg-dark">
                        <a className="navbar-brand" href="#" style={{color: '#fff'}}>
                            <img src="https://firebasestorage.googleapis.com/v0/b/wti-services-jrz.appspot.com/o/logo.PNG?alt=media&token=bdabc8e2-afaf-4a63-9eba-999097e2469e" width="30" height="30" class="d-inline-block align-top" alt="" />
                            WTI - Servicios aduanales
                        </a>
                    </nav>
                </div>
            </header>
            <div className="row  bg-active dark">
                <div className="col-lg-6 col-md-8 col-sm-7">
                    <div className="list-inline">
                        <a href="tel:+526564415210"><i className="fa fa-phone"></i>¿Necesitas ayuda? +52 656 441 5210</a>
                        <a href="tel:info@WTIServiciosAduanales.com"><i className="fa fa-envelope"></i>info@WTIServiciosAduanales.com</a>
                    </div>
                </div>
            </div>
        </React.Fragment>

    )
}

export default Navbar



// WEBPACK FOOTER //
// ./src/components/Global/Navbar.jsx